<template>
<div class="datetime">
  <label
    :for="dateLbl"
  >
    {{ labelText }}
  </label>

  <div class="input-group">
    <input
      type="date"
      :id="dateLbl"
      class="form-control"
      v-model="datetimeDate"
      v-on:change="setDatetimeUTC"
    />

    <input
      type="time"
      :id="timeLbl"
      class="form-control"
      v-model="datetimeTime"
      v-on:change="setDatetimeUTC"
    />

    <input
      type="hidden"
      :name="name"
      :id="name"
      :value="hiddenValue"
    />
  </div>
  <p
    class="alert alert-warning text-center"
    role="alert"
  >
    This date <span>and time</span>
    reflects your local timezone.
  </p>
</div>
</template>

<script>
/*
  This is a convenience component to display a better datetime input control
  without the timezone issues of `datetime-local` or browser problems.

  @todo Embed zeropad method, or require separate date formatting component.
  @todo Improve model handling.

  @prop labelText [String] The label text for the datetime control.
  @prop name [String] The base name string for the input name.
  @prop value [String|Date] The active datetime value.
*/

export default {
  data () {
    let state = {
      datetime: undefined,
      hiddenValue: undefined
    }

    return state
  },

  computed: {
    computedDatetime () {
      // Timezone offset.
      let val
      if (this.value) {
        val = new Date(this.value)
      }

      return this.datetime || val
    },

    datetimeDate: {
      get () {
        if (!this.computedDatetime) { return null }

        const val = new Date(this.computedDatetime)

        return this.dateToStr(val)
      },

      set (d) {
        this.datetime = d + (this.datetimeTime ? ('T' + this.datetimeTime) : '')

        return d
      }
    },

    dateLbl () {
      return 'date-' + this.rndLbl
    },

    timeLbl () {
      return 'time-' + this.rndLbl
    },

    datetimeTime: {
      get () {
        if (!this.computedDatetime) { return null }

        const val = new Date(this.computedDatetime)

        return this.timeToStr(val)
      },

      set (t) {
        this.datetime = this.datetimeDate + 'T' + t
      }
    },

    dateName () {
      return this.name + '_date'
    },

    timeName () {
      return this.name + '_time'
    }
  },

  props: {
    labelText: {
      type: [ Number, String ],
      default: undefined
    },

    id: {
      type: [ Number, String ],
      default: undefined
    },

    name: {
      type: [ Number, String ],
      default: undefined
    },

    value: {
      type: [ Number, String ],
      default: undefined
    }
  },

  created () {
    // Sufficiently randomize ids.
    const rnd = new Uint32Array(5)
    this.rndLbl = window.crypto.getRandomValues(rnd).join('').substr(0, 5)
    this.hiddenValue = this.value
  },

  methods: {
    getOffset () {
      return new Date().getTimezoneOffset() / 60
    },

    setDatetimeUTC () {
      this.hiddenValue = this.dateTimeToStr(
        this.setTimezoneOffset(
          new Date(this.datetime)
        )
      )
    },

    setTimezoneOffset (d) {
      const offset = this.getOffset()
      d.setHours(d.getHours() + offset)

      return d
    },

    dateTimeToStr (d) {
      return this.dateToStr(d) + 'T' + this.timeToStr(d)
    },

    dateToStr (d) {
      return [
        d.getFullYear(),
        this.$root.zeropad(d.getMonth() + 1),
        this.$root.zeropad(d.getDate())
      ].join('-')
    },

    timeToStr (t) {
      return [
        this.$root.zeropad(t.getHours()),
        this.$root.zeropad(t.getMinutes())
      ].join(':')
    }
  }
}
</script>

<style scoped>
input[type=date] {
  border-right: 0
}

input[type=time] {
  border-left: 0
}
</style>



// WEBPACK FOOTER //
// src/components/Datetime.vue